export const CONFIG = {
  apiPrefix: '/api/v1',

  gridPageSizes: [20, 50, 100],
  defaultPageSize: 20,
};
